// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3tz1i","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3eklI","obliqueLine":"membershipbadge_obliqueLine__2wJ-N"};